// Returns the origin to prefix onto v2 (React) URLs from the v1 (Vue) app.
// In dev, v2 is served on a separate port. In every deployed environment
// v1 and v2 are served from the same host, so use window.location.origin —
// that way staging.app.boomnow.com stays on staging and app.boomnow.com
// stays on prod, instead of every non-dev environment hardcoding prod.
export function getV2BaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8081'
  }
  return window.location.origin
}
